import { plans } from "./data";

const getTeamMembership = currentUser => {
    const {
        isIconProTeamOwner,
        isCreatorProTeamOwner,
        isIconProTeamMember
    } = currentUser;

    let membership = plans.creatorProTeamMember;

    if (isIconProTeamOwner) {
        membership = plans.iconProTeamOwner;
    } else if (isCreatorProTeamOwner) {
        membership = plans.creatorProTeamOwner;
    } else if (isIconProTeamMember) {
        membership = plans.iconProTeamMember;
    }

    return membership;
};

const getSubMembership = currentUser => {
    let membership = plans.iconProMember;

    if (currentUser.hasCreatorProSubscription) {
        membership = plans.creatorProMember;
    }

    return membership;
};

const finalizeMembership = (membership, isEligibleForCreatorPro) => {
    const updatedMembership = { ...membership };

    // (isEligibleForCreatorPro === false) users do NOT get upsellHtml
    if (!isEligibleForCreatorPro) {
        updatedMembership.upsellHtml = "";
    }

    return updatedMembership;
};

/**
 * getMembership
 * Ascertain Plan Logic
 * @param {Object} currentUser
 * @returns {Object} membership
 *
 * Considerations from Drew's PR" https://github.com/TheNounProject/Noun-Project/pull/9101
 *
 * 1. Prioritize Edu Subs First: `hasEduSubscription` === true will always return `hasIconProSubscription` === true
 * 2. Prioritize Teams Second: `hasIconProSubscription` and `hasCreatorProSubscription` do not distinguish
 *      between individual and team subscriptions. You'll need to check
 *      whether they're part of a team
 * 3. Users can be part of multiple plans and also have an individual subscription.
 *      It's up to Sarah to decide what you want to prefer in those cases, but
 *      you can look at templates/accounts/base_account_form.html
 *      to see the currernt precedence. It's messy.
 */
export const getMembership = currentUser => {
    // Default to Free
    let membership = plans.freeMember;

    const {
        // these users do NOT get upsellHtml
        isEligibleForCreatorPro = false,

        // has
        hasCreatorProSubscription = false,
        hasIconProSubscription = false,
        hasEduSubscription = false,

        // is a part of, or owns a team
        isIconProTeamOwner = false,
        isCreatorProTeamOwner = false,
        isCreatorProTeamMember = false,
        isIconProTeamMember = false
    } = currentUser;

    if (!currentUser?.hasSubscription)
        return finalizeMembership(membership, isEligibleForCreatorPro);

    if (hasEduSubscription)
        return finalizeMembership(plans.eduMember, isEligibleForCreatorPro);

    // Teams
    const isPartOfATeam = [
        isIconProTeamOwner,
        isCreatorProTeamOwner,
        isIconProTeamMember,
        isCreatorProTeamMember
    ].some(Boolean);

    // Standard Subscription
    const hasMembership = hasIconProSubscription || hasCreatorProSubscription;

    if (isPartOfATeam) {
        membership = getTeamMembership(currentUser);
    } else if (hasMembership) {
        membership = getSubMembership(currentUser);
    }

    return finalizeMembership(membership, isEligibleForCreatorPro);
};
